import React  from 'react'
import './loader.css'

const Loader = props => {
    return (
        <div id="loader-dim">
            <div className="loader"></div>
        </div>
    )
}

export default Loader